const spellingResult = {
    namespaced: true,
    state: {
        // Spelling State
        dataSpellingCurrent: '',
        isShowSpellingPageDetail: false,
        currentSpellingTooltip: -1,
        currentSpellingPageDetail: 0
    },
    mutations: {
        UPDATE_DATA_SPELLING_CURRENT(state, dataSpelling) {
            state.dataSpellingCurrent = dataSpelling
        },
        UPDATE_IS_SHOW_SPELLING_PAGE_DETAIL(state, isShow) {
            state.isShowSpellingPageDetail = isShow
        },
        UPDATE_CURRENT_SPELLING_TOOLTIP(state, num) {
            state.currentSpellingTooltip = num
        },
        UPDATE_CURRENT_SPELLING_PAGE_DETAIL(state, page) {
            state.currentSpellingPageDetail = page
        }
    },
    actions: {
        updateDataSpellingCurrent({ commit }, dataSpelling) {
            commit('UPDATE_DATA_SPELLING_CURRENT', dataSpelling)
        },
        updateIsShowSpellingPageDetail({ commit }, isShow) {
            commit('UPDATE_IS_SHOW_SPELLING_PAGE_DETAIL', isShow)
        },
        updateCurrentSpellingTooltip({ commit }, num) {
            commit('UPDATE_CURRENT_SPELLING_TOOLTIP', num)
        },
        updateCurrentSpellingPageDetail({ commit }, page) {
            commit('UPDATE_CURRENT_SPELLING_PAGE_DETAIL', page)
        }
    },
    getters: {
        dataSpellingCurrent: state => state.dataSpellingCurrent,
        isShowSpellingPageDetail: state => state.isShowSpellingPageDetail,
        currentSpellingTooltip: state => state.currentSpellingTooltip,
        currentSpellingPageDetail: state => state.currentSpellingPageDetail
    }
}

export default spellingResult
